import React from 'react';
import './BebekOdakliSection.css';
import bebekImage from '../../assets/img/yenigorsel/bebek.jpg';

const BebekOdakliSection: React.FC = () => {
    const handleWhatsAppClick = (message: string) => {
        const phoneNumber = '905369900797'; // Thermomix Dünyası numarası
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    };

    return (
        <section className="bebek-odakli-section">
            <div className="bebek-container">
                <div className="bebek-content">
                    <div className="bebek-image-container">
                        <img src={bebekImage} alt="Bebek Maması" className="bebek-image" loading="lazy" />
                    </div>
                    <div className="bebek-info">
                        <h2 className="bebek-title">
                            <span className="highlight">Bebekli Aileler</span> İçin Özel!
                        </h2>
                        <p className="bebek-description">
                            Katkısız, doğal, hijyenik mama ve püre tarifleri — Thermomix ile dakikalar içinde.
                        </p>
                        <div className="bebek-buttons">
                            <button
                                className="whatsapp-btn primary"
                                onClick={() => handleWhatsAppClick('Bebek maması hakkında bilgi almak istiyorum')}
                            >
                                <i className="fab fa-whatsapp"></i>
                                Bebek maması hakkında bilgi almak istiyorum
                            </button>
                            <button
                                className="whatsapp-btn secondary"
                                onClick={() => handleWhatsAppClick('Bebek tarifleri için demo talep ediyorum')}
                            >
                                <i className="fab fa-whatsapp"></i>
                                Bebek tarifleri için demo talep ediyorum
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default BebekOdakliSection;
